const translations = {
  pdp_status_low_in_stock: "LOW STOCK",
  pdp_status_out_of_stock: "OUT OF STOCK",
};

export type MappedVariant = {
  value: string;
  label: string;
  status: "default" | "disabled" | "alert";
  statusLabel?: string;
};

export type SelectableVariant = {
  id?: number;
  brandSize: string;
  isInStock: boolean;
  isLowInStock: boolean;
};

export const mapSelectableVariants = (
  variants: SelectableVariant[],
): MappedVariant[] => {
  return variants
    .filter((variant) => variant.id !== undefined)
    .map((variant) => {
      const isOutOfStock = !variant.isInStock;

      return {
        value: String(variant.id),
        label: variant.brandSize,
        status: isOutOfStock
          ? "disabled"
          : variant.isLowInStock
            ? "alert"
            : "default",
        statusLabel: isOutOfStock
          ? translations.pdp_status_out_of_stock
          : variant.isLowInStock
            ? translations.pdp_status_low_in_stock
            : undefined,
      };
    });
};
